import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceEstablishmentChoiceAuctionEntryUnpauseProps {
  establishmentChoiceId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntryUnpause = ({
  establishmentChoiceId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryUnpauseProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceAuctionEntryUnpause'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/auction_entries/${establishmentChoiceId}/unpause`);
    },
    ...options
  });
}
